export default __webpack_public_path__ + "static/media/asset_artifact_empty.fcc19315.svg";